// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {entries} from '@benchling/js-utils';
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {debounce} from 'ts-debounce';
import _ from 'underscore';

import * as OnboardingActions from 'actions/OnboardingActions';
import {Analyses, Analysis, AnalysisAttributes} from 'analyses/Analyses';
import * as analytics from 'analytics/Analytics';
import AntibodyHistoryPanelView from 'antibodies/panels/AntibodyHistoryPanelView';
import {MolbioFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {Sequence} from 'biojs/Sequence';
import {MoleculeToolbarState} from 'chemistry/molecules/tabs/MoleculeFileState';
import {SequenceVersion} from 'components/Sequence';
import {ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {StrandOfDoubleStranded} from 'constants/MolbioConstants';
import {NUEModuleState} from 'constants/OnboardingConstants';
import OnboardingConstants from 'constants/OnboardingConstants';
import * as SequenceAnalysisConstants from 'constants/SequenceAnalysisConstants';
import FileState from 'filestate/FileState';
import {
  AaSequenceToolbarState,
  SequenceToolbarState,
  BasicFolderItemToolbarState,
  EntryToolbarState,
  TemplateToolbarState,
  SubtemplateToolbarState,
  SequenceFileState,
  FeaturePanelState,
  BasicFolderItemFileState,
} from 'FileStates';
import HomeDashboardStore from 'home-dashboard/HomeDashboardStore';
import {isComplexPolymer} from 'modbio/complex-polymers/ComplexPolymerUtil';
import ComplexPolymerHistoryPanelView from 'modbio/complex-polymers/panels/ComplexPolymerHistoryPanelView';
import Annotation from 'molbio/annotations/backbone/Annotation';
import CutSite from 'molbio/enzymes/backbone/CutSite';
import {Selection} from 'molbio/maps/selectables/Selection';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import Translation from 'molbio/translations/backbone/Translation';
import EntryHistoryPanelView from 'notebook/entries/backbone/panels/EntryHistoryPanelView';
import EntryInformationPanelView from 'notebook/entries/backbone/panels/EntryInformationPanelView';
import SubtemplateHistoryPanelView from 'notebook/entry-templates/backbone/panels/SubtemplateHistoryPanelView';
import SubtemplateInformationPanelView from 'notebook/entry-templates/backbone/panels/SubtemplateInformationPanelView';
import TemplateHistoryPanelView from 'notebook/entry-templates/backbone/panels/TemplateHistoryPanelView';
import TemplateInformationPanelView from 'notebook/entry-templates/backbone/panels/TemplateInformationPanelView';
import ProtocolHistoryPanelView from 'notebook/protocols/backbone/panels/ProtocolHistoryPanelView';
import ProtocolInformationPanelView from 'notebook/protocols/backbone/panels/ProtocolInformationPanelView';
import SequenceNUEModule from 'onboarding/SequenceNUEModule';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';
import AaSequenceAlignmentPanelView from 'toolbar/aa-sequence/AaSequenceAlignmentPanelView';
import AaSequenceAnnotationsPanelView from 'toolbar/aa-sequence/AaSequenceAnnotationsPanelView';
import AaSequenceHistoryPanelView from 'toolbar/aa-sequence/AaSequenceHistoryPanelView';
import AaSequenceInformationPanelView from 'toolbar/aa-sequence/AaSequenceInformationPanelView';
import AlignmentPanelView from 'toolbar/AlignmentPanelView';
import FeaturePanelView from 'toolbar/feature-panel/FeaturePanelView';
import GenomeEngineeringPanelView from 'toolbar/GenomeEngineeringPanelView';
import MoleculeHistoryPanelView from 'toolbar/molecule/MoleculeHistoryPanelView';
import MoleculeInformationPanelView from 'toolbar/molecule/MoleculeInformationPanelView';
import PrimerPanelView from 'toolbar/primer-panel/PrimerPanelView';
import RestrictionPanelView from 'toolbar/restriction-panel/RestrictionPanelView';
import SequenceHistoryPanelView from 'toolbar/SequenceHistoryPanelView';
import SequenceInformationPanelView from 'toolbar/SequenceInformationPanelView';
import BasicInformationPanelView from 'toolbar/shared/BasicInformationPanelView';
import {
  TOOLBARS,
  ListenedPanelMapping,
  ListenedPanel,
  PanelNameToViewMapping,
  PanelStateNameToModelMapping,
  ModelTypeWithToolbar,
  PanelName,
  PanelId,
  PanelNameToIdMapping,
} from 'toolbar/ToolbarConstants';
import * as keyboard from 'util/Keyboard';
import {Optional} from 'util/Types';
import StageEntryHistoryPanelView from 'workflows/stage-entries/StageEntryHistoryPanelView';
import StageEntryInformationPanelView from 'workflows/stage-entries/StageEntryInformationPanelView';

const PANEL_OFFSET = 6;

interface ToolbarStateAttributes extends PanelStateNameToModelMapping {
  active: PanelId;
  position: number;
  panelShouldBeFullHeight?: Partial<Record<PanelId, boolean>>;
}

interface ToolbarStateClass {
  get<K extends keyof ToolbarStateAttributes>(key: K): ToolbarStateAttributes[K];
  set<K extends keyof ToolbarStateAttributes>(
    attributeName: K,
    value: ToolbarStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): ToolbarStateClass;
  set(obj: Partial<ToolbarStateAttributes>): ToolbarStateClass;
  unset<K extends keyof ToolbarStateAttributes>(key: K): ToolbarStateClass;
}

interface ToolbarPanelMetadata<TPanelId extends PanelId> {
  id: TPanelId;
  isMolbioOnlyTool?: boolean;
}

const TOOLBAR_PANELS: {[TPanelName in PanelName]: ToolbarPanelMetadata<PanelNameToIdMapping[TPanelName]>} = {
  featurePanel: {id: 'feature-panel', isMolbioOnlyTool: true},
  restrictionPanel: {id: 'restriction-panel', isMolbioOnlyTool: true},
  primerPanel: {id: 'primer-panel', isMolbioOnlyTool: true},
  informationPanel: {id: 'information-panel'},
  historyPanel: {id: 'history-panel', isMolbioOnlyTool: true},
  alignmentPanel: {id: 'alignment-panel', isMolbioOnlyTool: true},
  genomeEngineeringPanel: {id: 'genome-engineering-panel', isMolbioOnlyTool: true},
  entryInformationPanel: {id: 'entry-information-panel'},
  entryHistoryPanel: {id: 'entry-history-panel'},
  protocolInformationPanel: {id: 'protocol-information-panel'},
  protocolHistoryPanel: {id: 'protocol-history-panel'},
  subtemplateHistoryPanel: {id: 'subtemplate-history-panel'},
  subtemplateInformationPanel: {id: 'subtemplate-information-panel'},
  templateHistoryPanel: {id: 'template-history-panel'},
  templateInformationPanel: {id: 'template-information-panel'},
  basicFolderItemInformationPanel: {id: 'basic-folder-item-information-panel'},
  complexPolymerHistoryPanel: {id: 'complex-polymer-history-panel'},
  aaSequenceAnnotationsPanel: {id: 'aa-sequence-annotations-panel', isMolbioOnlyTool: true},
  aaSequenceHistoryPanel: {id: 'aa-sequence-history-panel', isMolbioOnlyTool: true},
  aaSequenceInformationPanel: {id: 'aa-sequence-information-panel'},
  aaSequenceAlignmentPanel: {id: 'aa-sequence-alignment-panel', isMolbioOnlyTool: true},
  stageEntryInformationPanel: {id: 'stage-entry-information-panel'},
  stageEntryHistoryPanel: {id: 'stage-entry-history-panel'},
  moleculeHistoryPanel: {id: 'molecule-history-panel'},
  moleculeInformationPanel: {id: 'molecule-information-panel'},
  antibodyHistoryPanel: {id: 'antibody-history-panel', isMolbioOnlyTool: true},
};

/**
 * Some panels have additional conditions for whether it should be shown.
 */
function customShouldShowPanel(panelName: PanelName, fileState: FileStateWithOptionalModel): boolean {
  switch (panelName) {
    case 'complexPolymerHistoryPanel':
      return isComplexPolymer(fileState.model?.().id ?? null);
    case 'antibodyHistoryPanel':
      return (fileState as BasicFolderItemFileState).get('antibodyData')?.isAntibody ?? false;
    default:
      return true;
  }
}

function getToolbarSelector(toolbarName: PanelName): string {
  return `#${TOOLBAR_PANELS[toolbarName].id}`;
}

/* @package - exported for testing */
export function isClickInsideMantinePortalOwnedByModal(target: EventTarget): boolean {
  const $target = $(target);
  const isMantineModalClick = $target.closest('.mantine-Modal-root').length > 0;
  const isMantineModalDropdownClick =
    $('.mantine-Modal-root').length > 0 && $target.closest('.mantine-Select-dropdown').length > 0;
  return isMantineModalClick || isMantineModalDropdownClick;
}

// Declare that the ToolbarView class has all the attributes of the PanelNameToViewMapping interface.
interface ToolbarView extends PanelNameToViewMapping, ListenedPanelMapping {}

interface FileStateWithOptionalModel extends FileState {
  model?(): {id: string};
}

class ToolbarView extends Backbone.View<Backbone.Model> {
  // @ts-expect-error: Backbone expects events to be a method
  events!: EventsHash;

  // A Backbone model that includes PanelStateNameToModelMapping in its attributes. In reality, no
  // ToolbarStateClass contains the entirety of the PanelStateNameToModelMapping interface, but it's easier to paper
  // over this fact.
  toolbarState!: ToolbarStateClass | null;
  selection?: Selection;
  _sequence?: Sequence;
  analyses?: Analyses<Analysis, AnalysisAttributes>;
  fileState?: FileStateWithOptionalModel | null;
  handleHomeDashboardStoreChangeListener!: null | (() => void);

  sequenceNUEModuleReactRoot: ReactDOM.Root | null = null;

  static initClass(): void {
    this.prototype.el = '#toolbar';
    this.prototype.events = {
      'click .js-toolbarBtn': 'iconClick',
      'click .js-sequence-nue-button': 'sequenceNUEButtonClick',
    };
  }

  override initialize(): void {
    this.resizePanel = this.resizePanel.bind(this);
    // SEQUENCE
    this.featurePanel = new FeaturePanelView({
      el: getToolbarSelector('featurePanel'),
    });
    this.restrictionPanel = new RestrictionPanelView();
    this.primerPanel = new PrimerPanelView();
    this.informationPanel = new SequenceInformationPanelView();
    this.historyPanel = new SequenceHistoryPanelView();
    this.alignmentPanel = new AlignmentPanelView();
    this.genomeEngineeringPanel = new GenomeEngineeringPanelView({
      el: getToolbarSelector('genomeEngineeringPanel'),
    });

    // ENTRY
    this.entryInformationPanel = new EntryInformationPanelView({
      el: getToolbarSelector('entryInformationPanel'),
    });
    this.entryHistoryPanel = new EntryHistoryPanelView({el: getToolbarSelector('entryHistoryPanel')});

    // PROTOCOL
    this.protocolInformationPanel = new ProtocolInformationPanelView({
      el: getToolbarSelector('protocolInformationPanel'),
    });
    this.protocolHistoryPanel = new ProtocolHistoryPanelView({
      el: getToolbarSelector('protocolHistoryPanel'),
    });

    // SUBTEMPLATE
    this.subtemplateHistoryPanel = new SubtemplateHistoryPanelView({
      el: getToolbarSelector('subtemplateHistoryPanel'),
    });
    this.subtemplateInformationPanel = new SubtemplateInformationPanelView({
      el: getToolbarSelector('subtemplateInformationPanel'),
    });

    // TEMPLATE
    this.templateHistoryPanel = new TemplateHistoryPanelView({
      el: getToolbarSelector('templateHistoryPanel'),
    });
    this.templateInformationPanel = new TemplateInformationPanelView({
      el: getToolbarSelector('templateInformationPanel'),
    });

    // AA SEQUENCE
    this.aaSequenceAnnotationsPanel = new AaSequenceAnnotationsPanelView({
      el: getToolbarSelector('aaSequenceAnnotationsPanel'),
    });
    this.aaSequenceHistoryPanel = new AaSequenceHistoryPanelView({
      el: getToolbarSelector('aaSequenceHistoryPanel'),
    });
    this.aaSequenceInformationPanel = new AaSequenceInformationPanelView({
      el: getToolbarSelector('aaSequenceInformationPanel'),
    });
    this.aaSequenceAlignmentPanel = new AaSequenceAlignmentPanelView({
      el: getToolbarSelector('aaSequenceAlignmentPanel'),
    });

    // BASIC FOLDER ITEM
    this.basicFolderItemInformationPanel = new BasicInformationPanelView({
      el: getToolbarSelector('basicFolderItemInformationPanel'),
    });

    this.complexPolymerHistoryPanel = new ComplexPolymerHistoryPanelView({
      el: getToolbarSelector('complexPolymerHistoryPanel'),
    });

    this.antibodyHistoryPanel = new AntibodyHistoryPanelView({
      el: getToolbarSelector('antibodyHistoryPanel'),
    });

    // STAGE ENTRY
    this.stageEntryInformationPanel = new StageEntryInformationPanelView({
      el: getToolbarSelector('stageEntryInformationPanel'),
    });
    this.stageEntryHistoryPanel = new StageEntryHistoryPanelView({
      el: getToolbarSelector('stageEntryHistoryPanel'),
    });

    // MOLECULE
    this.moleculeHistoryPanel = new MoleculeHistoryPanelView({
      el: getToolbarSelector('moleculeHistoryPanel'),
    });
    this.moleculeInformationPanel = new MoleculeInformationPanelView({
      el: getToolbarSelector('moleculeInformationPanel'),
    });

    this.handleHomeDashboardStoreChangeListener = null;

    // @ts-expect-error: should remove return statement
    return this.$el.find('.js-toolbarBtn-tooltipWrapper').tooltip({
      placement: 'left',
      delay: {
        show: 500,
        hide: 100,
      },
      container: 'body',
    });
  }

  trackIconClick(panelId: PanelId): void {
    const sequenceId = (this.fileState as SequenceFileState).model().get('id');
    switch (panelId) {
      case 'primer-panel':
        analytics.track('primer', 'open_primer_panel', {
          product: ANALYTICS_MODULE.MOLBIO,
          sequence_id: sequenceId,
        });
        break;
      case 'feature-panel':
        analytics.track('annotation', 'open_annotation_panel', {
          product: ANALYTICS_MODULE.MOLBIO,
          openedFrom: 'toolbar',
          sequence_id: sequenceId,
        });
        break;
      case 'aa-sequence-annotations-panel':
        // The event category and the protein_id property are analytics names, not UI
        // identifiers. Renaming them would split metric continuity at the deploy, so they
        // keep the legacy spelling.
        analytics.track('protein', 'open_annotation_panel', {
          product: ANALYTICS_MODULE.MOLBIO,
          openedFrom: 'toolbar',
          protein_id: sequenceId,
        });
        break;
      default:
        break;
    }
  }

  iconClick(e: JQueryEventObject): void {
    const node = $(e.target).closest('.panel-wrapper');
    node.find('.js-toolbarBtn-tooltipWrapper').tooltip('hide');
    if (node.hasClass('active')) {
      this.closeAndDeactivate();
    } else {
      const panelId = node.attr('id') as PanelId;
      this.trackIconClick(panelId);
      this.activateAndOpen(panelId);
    }
  }

  sequenceNUEButtonClick(e: JQueryEventObject): void {
    const isSequenceNUEModuleCollapsed = __guard__(
      this.getHomeDashboardStoreModuleState(),
      (x) => x.collapsed
    );
    OnboardingActions.toggleCollapsedNUEModule(
      OnboardingConstants.MODULES.SEQUENCE,
      !isSequenceNUEModuleCollapsed
    );
    const action = !isSequenceNUEModuleCollapsed ? 'minimized' : 'expanded';
    analytics.track('onboarding_checklist', action, {
      checklist: 'molecular_biology',
      checklistTitle: 'Explore Molecular Biology to Earn Space',
      checklistReward: '1GB_earned',
      numberOfTasks: 5,
      eventLastModified: 'FY21_Q1a2',
    });
  }

  closePanel(): void {
    const panelWrapper = this.$el.find('.panel-wrapper.active');
    const activePanel = panelWrapper.attr('id') as PanelId;
    if (activePanel != null) {
      const mappedPanelId = this.panelIdMap(activePanel);
      this[mappedPanelId].trigger('close');
      const panelState = this.toolbarState!.get(`${mappedPanelId}State`);
      panelState.set({active: false});
    }
    panelWrapper.removeClass('active');
    $(window).off('mousedown', this._handleWindowClick);
    // @ts-expect-error: should remove this return statement
    return panelWrapper.find('.js-toolbarBtn.button--circleIcon').removeClass('is-active');
  }

  shouldPanelBeFullHeight(): boolean | undefined {
    const panelShouldBeFullHeight = this.toolbarState!.get('panelShouldBeFullHeight');
    if (panelShouldBeFullHeight == null) {
      return false;
    } else {
      const activePanel = this.toolbarState!.get('active');
      return panelShouldBeFullHeight[activePanel];
    }
  }

  resizePanel(): void {
    if (this.toolbarState == null) {
      return;
    }
    const activePanel = this.toolbarState.get('active');
    const panel = this.$el.find(`#${activePanel}`);
    const panelDiv = panel.find('.panel .panel-content');
    const parentPanel = panelDiv.closest('.panel');
    const shouldPanelBeFullHeight = this.shouldPanelBeFullHeight();

    if (activePanel != null) {
      // Temporarily reset height / position restrictions so we can measure its ideal size.
      // The user won't visibly see this since this function is run synchronously with a reflow.
      panelDiv.css('max-height', 'none');
      const offsetLeft = parentPanel.offset()?.left ?? 0;
      const offsetTop = parentPanel.offset()?.top ?? 0;
      parentPanel.offset({left: offsetLeft, top: this.toolbarState.get('position')});

      // Where panel extends to without height restrictions.
      // @ts-expect-error Unused variable
      const computedBottom = offsetTop + panelDiv.outerHeight(true);

      // Where panel is allowed to extend to.
      let windowBottom = $(window).height() - $('#statusbar').height() - 10;
      if (!$('#assembly-wizard-container').hasClass('hidden')) {
        windowBottom -= 140;
      }

      const availableHeight = windowBottom - offsetTop - 10; // padding
      const desiredHeight = shouldPanelBeFullHeight
        ? availableHeight
        : Math.min(availableHeight, 380, panelDiv.height());
      if (shouldPanelBeFullHeight) {
        parentPanel.height(desiredHeight);
        panelDiv.css('height', desiredHeight);
      }

      // Reposition closer to top of the screen if our height would guarantee pushing the panel off screen.
      const newTop = Math.min(offsetTop, windowBottom - desiredHeight);
      parentPanel.offset({left: offsetLeft, top: newTop});

      // Ensure we never extend pass the bottom of the screen.
      const maxHeight = windowBottom - newTop - parentPanel.find('.panel-title').height();
      panelDiv.css('max-height', maxHeight);
    }
  }

  // In theory this could be narrowed - it should be fetching specifically the PanelName that corresponds to the PanelId.
  // It's challenging to type though since it involves inferring the key of a type interface, not the corresponding value.
  panelIdMap(panelId: PanelId): PanelName {
    return entries(TOOLBAR_PANELS).find(([, panel]) => panel.id === panelId)![0];
  }

  _handleWindowClick = (e: JQueryEventObject): void => {
    // Close info panel if user clicks window outside panel, as long as no modal is open on top and
    // no context menu or other overlaid element is active
    const panelWrapper = this.$el.find('.panel-wrapper.active').get(0);
    const $target = $(e.target);
    if (
      panelWrapper &&
      !panelWrapper.contains(e.target) &&
      $('.modal-open').length === 0 &&
      $('#context-menu:visible').length === 0 &&
      !$target.hasClass('backdrop') &&
      $target.parents('.absoluteDropdownContainer').length === 0 &&
      // Mantine Modals render into portals outside the panel DOM. Their dropdowns do too, so scope
      // this exemption to dropdown clicks while a modal is present.
      !isClickInsideMantinePortalOwnedByModal(e.target)
    ) {
      this.closeAndDeactivate();
    }
  };

  openPanel(): void {
    this.closePanel();
    const activePanel = this.toolbarState!.get('active');
    $(window).on('mousedown', this._handleWindowClick);

    if (activePanel != null) {
      analytics.track('editor', 'open_panel', {panel: activePanel});
      const panelWrapper = this.$el.find(`#${activePanel}`);
      panelWrapper.addClass('active');
      panelWrapper.find('.js-toolbarBtn.button--circleIcon').addClass('is-active');
      const panelDiv = panelWrapper.find('.panel');

      // Once the panel is mounted and sized, set the panel's position next to the button
      const panelOffset = panelDiv.offset();
      if (panelOffset != null) {
        const offset = {
          left: panelOffset.left,
          top: this.toolbarState!.get('position'),
        };
        panelDiv.offset(offset);
      }

      const mappedPanelId = this.panelIdMap(activePanel);
      const panelView = this[mappedPanelId];
      const panelState = this.toolbarState!.get(`${mappedPanelId}State`);

      // For backwards compatibility, we include fileState.model() since most panel views expect to receive a
      // BaseFile instance; however, a FileState instance should be all that is needed (esp. since having not
      // all FileStates have a model)
      panelView.update(
        panelState,
        this.fileState != null ? this.fileState.model!() : undefined,
        this.fileState
      );

      panelView.trigger('open');
      panelState.set({active: true});

      // Many panels render asynchronously via ReduxDOMRender.renderToDOM, so we wait a tick to reposition
      // the panel.
      _.defer(() => {
        this.resizePanel();
      });
    }
  }

  updateSubtemplate(toolbarState: SubtemplateToolbarState): void {
    this.listenTo(toolbarState, 'openHistoryPanel', function () {
      // @ts-expect-error: `this` is shadowed
      return this.activateAndOpen('subtemplate-history-panel');
    });
    this.listenTo(toolbarState, 'openInformationPanel', function () {
      // @ts-expect-error: `this` is shadowed
      return this.activateAndOpen('subtemplate-information-panel');
    });
  }

  updateTemplate(toolbarState: TemplateToolbarState): void {
    this.listenTo(toolbarState, 'openHistoryPanel', function () {
      // @ts-expect-error: `this` is shadowed
      return this.activateAndOpen('template-history-panel');
    });
    this.listenTo(toolbarState, 'openInformationPanel', function () {
      // @ts-expect-error: `this` is shadowed
      return this.activateAndOpen('template-information-panel');
    });
  }

  updateEntry(toolbarState: EntryToolbarState): void {
    this.listenTo(toolbarState, 'openHistoryPanel', function () {
      // @ts-expect-error: `this` is shadowed
      return this.activateAndOpen('entry-history-panel');
    });
    this.listenTo(toolbarState.get('entryInformationPanelState'), 'close', function () {
      // @ts-expect-error: `this` is shadowed
      return this.closeAndDeactivate();
    });
  }

  updateBasicFolderItem(toolbarState: BasicFolderItemToolbarState): void {
    this.listenTo(toolbarState.get('basicFolderItemInformationPanelState'), 'close', function () {
      // @ts-expect-error: `this` is shadowed
      return this.closeAndDeactivate();
    });
  }

  updateOligo(toolbarState: SequenceToolbarState): void {
    const sequence = (this.fileState as SequenceFileState).model();
    this.selection = sequence.get('selection');
    this._sequence = sequence.get('_sequence');

    this.listenTo(toolbarState, 'openHistoryPanel', function () {
      // @ts-expect-error: `this` is shadowed
      return this.activateAndOpen('history-panel');
    });

    this.listenTo(this.selection, 'annotation', (annotation: Annotation | null) => {
      (this.toolbarState!.get('featurePanelState') as unknown as FeaturePanelState).createAnnotation(
        sequence.id,
        this.selection!
      );
      this.activateAndOpen('feature-panel');
      // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
      return annotation != null ? annotation.select() : undefined;
    });

    const versions = sequence.get('versions');
    this.listenTo(versions, 'open', (version: SequenceVersion) => {
      if (this.toolbarState!.get('active') !== 'history-panel' && sequence.getActiveVersion() !== version) {
        this.activateAndOpen('history-panel');
        return versions.trigger('open', version);
      }
    });

    if (sequence.name() === 'Untitled' && !this.toolbarState!.get('active')) {
      this.activateAndOpen('information-panel');
    }

    const listenedPanels: Array<ListenedPanel> = ['feature', 'information', 'history'];
    for (const panel of listenedPanels) {
      if (this[`${panel}-panel-ref`]) {
        this.stopListening(this[`${panel}-panel-ref`]);
      }
      const panelState = this.toolbarState!.get(`${panel}PanelState`);
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.listenTo(panelState, 'resize', this.resizePanel);
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.listenTo(panelState, 'close', this.closeAndDeactivate);
      // @ts-expect-error: this is actually correct but it's not detected that it is listening to one panel instead of a union
      this[`${panel}-panel-ref`] = panelState;
    }
  }

  updateSequence(toolbarState: SequenceToolbarState): void {
    const sequence = (this.fileState as SequenceFileState).model();

    this.analyses = sequence.get('analyses');
    this.selection = sequence.get('selection');

    this._sequence = sequence.get('_sequence');

    this.listenTo(toolbarState, 'openHistoryPanel', function () {
      // @ts-expect-error: `this` is shadowed
      return this.activateAndOpen('history-panel');
    });

    this.listenTo(this.selection, 'annotation', (annotation: Annotation | null) => {
      (this.toolbarState!.get('featurePanelState') as unknown as FeaturePanelState).createAnnotation(
        sequence.id,
        this.selection!
      );
      this.activateAndOpen('feature-panel');
      // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
      return annotation != null ? annotation.select() : undefined;
    });
    this.listenTo(
      this.selection,
      'translation-panel',
      (strand: StrandOfDoubleStranded | null, translation: Translation | null) => {
        if (strand != null) {
          (this.toolbarState!.get('featurePanelState') as unknown as FeaturePanelState).createTranslation(
            sequence.id,
            strand
          );
        }
        this.activateAndOpen('feature-panel');
        return translation?.select();
      }
    );
    this.listenTo(this.selection, 'primer', (primer: SequencePrimer | null) => {
      if (primer != null) {
        primer.select();
      }
      const panelState = this.toolbarState!.get('primerPanelState');
      panelState.set({activeSubPanel: 'primers'});
      // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
      return this.activateAndOpen('primer-panel');
    });
    this.listenTo(this.selection, 'showLinks', () => {
      this.activateAndOpen('primer-panel');
      this.primerPanel.showLinks();
    });

    this.listenTo(this.selection, 'cutsite', (cutsite: CutSite | null) => {
      this.toolbarState!.get('restrictionPanelState').set('activeSubPanel', 'new-digest');
      this.activateAndOpen('restriction-panel');
      if (cutsite != null) {
        const enzyme = cutsite.get('enzyme');
        enzyme.trigger('zoomTo', {offset: 0, enzyme});
        return enzyme.trigger('showDetail', enzyme);
      }
    });

    this.listenTo(this.analyses, 'add', (analysis: Analysis) => {
      if (analysis.get('analysis_type') === SequenceAnalysisConstants.DIGEST) {
        this.toolbarState!.get('restrictionPanelState').set('activeSubPanel', 'my-digests');
        this.activateAndOpen('restriction-panel');
      }
    });
    const versions = sequence.get('versions');
    this.listenTo(versions, 'open', (version: SequenceVersion) => {
      if (this.toolbarState!.get('active') !== 'history-panel' && sequence.getActiveVersion() !== version) {
        this.activateAndOpen('history-panel');
        return versions.trigger('open', version);
      }
    });

    if (sequence.name() === 'Untitled' && this.toolbarState!.get('active') == null) {
      this.activateAndOpen('information-panel');
    }

    // TODO(eln): move these resize and close handlers somewhere they can be re-used across file types
    const listenedPanels: Array<ListenedPanel> = [
      'feature',
      'restriction',
      'primer',
      'alignment',
      'information',
      'history',
      'genomeEngineering',
    ];
    for (const panel of listenedPanels) {
      if (this[`${panel}-panel-ref`] != null) {
        this.stopListening(this[`${panel}-panel-ref`]);
      }
      const panelState = this.toolbarState!.get(`${panel}PanelState`);
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.listenTo(panelState, 'resize', this.resizePanel);
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.listenTo(panelState, 'close', this.closeAndDeactivate);
      // @ts-expect-error: this is actually correct but it's not detected that it is listening to one panel instead of a union
      this[`${panel}-panel-ref`] = panelState;
    }

    const alignmentsInProgress = this.toolbarState!.get('alignmentPanelState').get('alignmentsInProgress');
    const togglePulsing = (): void => {
      this.$('#alignment-panel .js-toolbarBtn.btn').toggleClass('pulsing', alignmentsInProgress.length > 0);
      this.$('#alignment-panel .js-toolbarBtn.button--circleIcon').toggleClass(
        'is-pulsing',
        alignmentsInProgress.length > 0
      );
    };
    this.listenTo(alignmentsInProgress, 'add remove', togglePulsing);
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return togglePulsing();
  }

  updateAaSequence(toolbarState: AaSequenceToolbarState): void {
    this.listenTo(toolbarState, 'openAaSequenceAnnotationsPanel', function () {
      // @ts-expect-error: `this` is shadowed
      return this.activateAndOpen('aa-sequence-annotations-panel');
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(toolbarState.get('aaSequenceAlignmentPanelState'), 'close', this.closeAndDeactivate);
    this.listenTo(toolbarState, 'openHistoryPanel', function () {
      // @ts-expect-error: `this` is shadowed
      return this.activateAndOpen('aa-sequence-history-panel');
    });
  }

  updateMolecule(toolbarState: MoleculeToolbarState): void {
    this.listenTo(toolbarState, 'openHistoryPanel', function () {
      // @ts-expect-error: `this` is shadowed
      return this.activateAndOpen('molecule-history-panel');
    });
    this.listenTo(toolbarState, 'openInformationPanel', function () {
      // @ts-expect-error: `this` is shadowed
      return this.activateAndOpen('molecule-information-panel');
    });
  }

  closeAndDeactivate(): void {
    this.closePanel();
    if (this.toolbarState != null) {
      this.toolbarState.unset('active');
    }
  }

  activateAndOpen(panelId: PanelId): void {
    this.toolbarState!.set('position', this.$el.find(`#${panelId}`).offset()!.top + PANEL_OFFSET);
    this.toolbarState!.set('active', panelId);
    this.openPanel();
  }

  toggleToolbar(shouldShowToolbar: boolean): void {
    this.$el.toggleClass('hidden', !shouldShowToolbar);
    $('#editor').toggleClass('has-hidden-toolbar', !shouldShowToolbar);
  }

  showToolbar(fileState: FileStateWithOptionalModel | null): void {
    let toolbarName: ModelTypeWithToolbar;
    if (fileState == null) {
      this.toggleToolbar(false);
      return;
    }

    if (fileState.fileType() === ModelTypeConstants.SEQUENCE) {
      toolbarName = (fileState as SequenceFileState).model().subtype();
    } else {
      toolbarName = fileState.fileType() as ModelTypeWithToolbar;
    }

    const toShow: Array<PanelId> = [];
    const toHide: Array<PanelId> = [];
    for (const [panelName, panelMetadata] of entries(TOOLBAR_PANELS)) {
      if (
        TOOLBARS[toolbarName] &&
        (TOOLBARS[toolbarName] as Array<PanelName>).includes(panelName) &&
        (!panelMetadata.isMolbioOnlyTool || isFeatureEnabled({feature: MolbioFeature.MOLBIO_EDIT})) &&
        customShouldShowPanel(panelName, fileState)
      ) {
        toShow.push(panelMetadata.id);
      } else {
        toHide.push(panelMetadata.id);
      }
    }

    const hasToolbar = toShow.length > 0;
    for (const panelId of toShow) {
      $(`#${panelId}`).removeClass('hidden');
    }
    for (const panelId of toHide) {
      $(`#${panelId}`).addClass('hidden');
    }

    this.toggleToolbar(hasToolbar);
  }

  getHomeDashboardStoreModuleState(): Optional<NUEModuleState> {
    return HomeDashboardStore.getNUEModuleState(OnboardingConstants.MODULES.SEQUENCE);
  }

  renderSequenceNUEModule(): void {
    if (this.handleHomeDashboardStoreChangeListener != null) {
      HomeDashboardStore.removeChangeListener(this.handleHomeDashboardStoreChangeListener);
    }
    const reactMount = this.$('.js-sequence-nue-mount')[0];
    const nueModuleState = this.getHomeDashboardStoreModuleState();
    if (reactMount == null) {
      return;
    }
    this.handleHomeDashboardStoreChangeListener = () => {
      const moduleState = this.getHomeDashboardStoreModuleState();
      $('.js-sequence-nue-button').toggleClass('hidden', !moduleState?.collapsed);
    };
    HomeDashboardStore.addChangeListener(this.handleHomeDashboardStoreChangeListener);
    const module = <SequenceNUEModule />;
    this.sequenceNUEModuleReactRoot = renderToDOM(module, reactMount, this.sequenceNUEModuleReactRoot);
    if (!nueModuleState?.completed) {
      // Only show module if tour has not been completed
      this.$el.find('.sequence-nue-container').removeClass('hidden');
    }
    if (nueModuleState?.collapsed) {
      // Only show icon in toolbar if module is collapsed
      this.$el.find('.js-sequence-nue-button').removeClass('hidden');
    }
  }

  update(toolbarState: ToolbarStateClass | null, fileState: FileState | null): void {
    $(window).off('.toolbarview');
    this.$el.off('.toolbarview');
    this.closePanel();

    if (this.toolbarState) {
      this.stopListening(this.toolbarState);
    }
    this.toolbarState = toolbarState;

    if (this.selection != null) {
      this.stopListening(this.selection);
    }
    if (this.analyses != null) {
      this.stopListening(this.analyses);
    }
    if (this._sequence != null) {
      this.stopListening(this._sequence);
    }

    this.fileState = fileState;
    if (!this.fileState) {
      this.showToolbar(null);
      return;
    }

    // eslint-disable-next-line @typescript-eslint/unbound-method
    $(window).on('resize.toolbarview', debounce(this.resizePanel, 150));
    // eslint-disable-next-line @typescript-eslint/unbound-method
    $(window).on('keyup.toolbarview', keyboard.onlyEscapeKey(this.closeAndDeactivate, this));
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.$el.on('update.toolbarview', this.resizePanel);

    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.toolbarState, 'close', this.closeAndDeactivate);
    const fileType = fileState!.fileType();
    this.showToolbar(fileState);
    if (fileType === ModelTypeConstants.SEQUENCE && !(fileState as SequenceFileState).model().isOligo()) {
      this.updateSequence(toolbarState as unknown as SequenceToolbarState);
    } else if (
      fileType === ModelTypeConstants.SEQUENCE &&
      (fileState as SequenceFileState).model().isOligo()
    ) {
      this.updateOligo(toolbarState as unknown as SequenceToolbarState);
    } else if (fileType === ModelTypeConstants.PROTEIN) {
      this.updateAaSequence(toolbarState as unknown as AaSequenceToolbarState);
    } else if (fileType === ModelTypeConstants.ENTRY) {
      this.updateEntry(toolbarState as unknown as EntryToolbarState);
    } else if (fileType === ModelTypeConstants.SUBTEMPLATE) {
      this.updateSubtemplate(toolbarState as unknown as SubtemplateToolbarState);
    } else if (fileType === ModelTypeConstants.TEMPLATE) {
      this.updateTemplate(toolbarState as unknown as TemplateToolbarState);
    } else if (fileType === ModelTypeConstants.BASIC_FOLDER_ITEM) {
      this.updateBasicFolderItem(toolbarState as unknown as BasicFolderItemToolbarState);
    } else if (fileType === ModelTypeConstants.MOLECULE) {
      this.updateMolecule(toolbarState as unknown as MoleculeToolbarState);
    }

    this.openPanel();
  }

  override remove(): Backbone.View<Backbone.Model> {
    unmountRootsAsync([this.sequenceNUEModuleReactRoot], () => {
      this.sequenceNUEModuleReactRoot = null;
      super.remove();
    });
    return this;
  }
}
ToolbarView.initClass();

export default ToolbarView;

function __guard__<T, V>(value: Optional<T>, transform: (t: T) => V): V | undefined {
  return value != null ? transform(value) : undefined;
}
